import { IIconProps } from "../types";
import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme, { size }: IIconProps) => ({
  icon: {
    minHeight: size || undefined,
    minWidth: size || undefined,
  },
}));
